import { render, staticRenderFns } from "./treeTwo.vue?vue&type=template&id=c0a00c10&scoped=true"
import script from "./treeTwo.vue?vue&type=script&lang=js"
export * from "./treeTwo.vue?vue&type=script&lang=js"
import style0 from "./treeTwo.vue?vue&type=style&index=0&id=c0a00c10&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a00c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a00c10')) {
      api.createRecord('c0a00c10', component.options)
    } else {
      api.reload('c0a00c10', component.options)
    }
    module.hot.accept("./treeTwo.vue?vue&type=template&id=c0a00c10&scoped=true", function () {
      api.rerender('c0a00c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/treeTwo.vue"
export default component.exports